import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Portfolio from './pages/Portfolio';
import BlogSection from './pages/BlogSection';
import FaqSection from './pages/FaqSection';
import AluminumGlassWorks from './pages/AluminumGlassWorks';
import FabricationWorks from './pages/FabricationWorks';
import RenovationWorks from './pages/RenovationWorks';
import Aluminiuamlglass from './pages/Aluminium Glass Office Partition Services';
import Alltypesoftough from './pages/All Types of Toughened Glass Work';
import Doorpatition from './pages/Door-Partition';
import ACPCladding from './pages/ACP-Cladding-Panel-Installation';
import Aluminiuamlglasswindow from './pages/Aluminium-Glass-Window';
import Soundproofglass from './pages/Soundproof-Glass-Window';
import Aluminiuamlmosquito from './pages/Aluminium-Mosquito-Net';
import Birdnetinstall from './pages/Bird-Net-Installation';
import Invisiblegrill from './pages/Invisible-Grill-Installation';
import Msfabricationdoor from './pages/MS-Fabrication-Door';
import Msfabricationshade from './pages/MS-Fabrication-Shade';
import MSfabricationgrill from './pages/MS-Fabrication-Grill';
import MSfabricationslide from './pages/MS-Fabrication-Slide-Door';
import Msfabricationindustrial from './pages/MS-Fabrication-Industrial-Shade';
import Industrialfabrication from './pages/Industrial-Fabrication-Work';
import Furniturework from './pages/Furniture-Work';
import Industrialwork from './pages/Industrial-Work';
import Homerenovation from './pages/Home-Renovation-Work';
import Foilceiling from './pages/Foil-Ceiling-Work';
import Paintingwork from './pages/Painting-Work';
import Electricwork from './pages/Electrical-Work';
import Puffpanelroom from './pages/Puff-Panel-Room';
import Maintenancerepail from './pages/Maintenance-Repair-Work';
import Pccepoxyflooring from './pages/PCC-Epoxy-Flooring-Work';
import ScrollToTop from './components/ScrollToTop';
import ContactButtons from './components/ContactButtons';
import Gallery from './pages/Gallery';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop/>
      <ContactButtons/>
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<BlogSection />} />
        <Route path="/faqs" element={<FaqSection />} />
        <Route path="/Aluminum-Glass-Works" element={<AluminumGlassWorks />} />
        <Route path="/Fabrication-Works" element={<FabricationWorks />} />
        <Route path="/Renovation-Works" element={<RenovationWorks />} />


        
        <Route path="/Aluminium-Glass-Office-Partition-Services-in-Pune" element={<Aluminiuamlglass />} />
<Route path="/Toughened-Glass-Work-Services-in-Pune" element={<Alltypesoftough />} />
<Route path="/Door-Partition-Services-in-Pune" element={<Doorpatition />} />
<Route path="/ACP-Cladding-Panel-Installation-Services-in-Pune" element={<ACPCladding />} />
<Route path="/Aluminium-Glass-Window-Installation-Services-in-Pune" element={<Aluminiuamlglasswindow />} />
<Route path="/Soundproof-Glass-Window-Installation-Services-in-Pune" element={<Soundproofglass />} />
<Route path="/Aluminium-Mosquito-Net-Installation-Services-in-Pune" element={<Aluminiuamlmosquito />} />
<Route path="/Bird-Net-Installation-Services-in-Pune" element={<Birdnetinstall />} />
<Route path="/Invisible-Grill-Installation-Services-in-Pune" element={<Invisiblegrill />} />
<Route path="/MS-Fabrication-Door-Installation-Services-in-Pune" element={<Msfabricationdoor />} />
<Route path="/MS-Fabrication-Shade-Installation-Services-in-Pune" element={<Msfabricationshade />} />
<Route path="/MS-Fabrication-Grill-Installation-Services-in-Pune" element={<MSfabricationgrill />} />

<Route path="/MS-Fabrication-Slide-Door-Installation-Services-in-Pune" element={<MSfabricationslide />} />
<Route path="/MS-Fabrication-Industrial-Shade-Services-in-Pune" element={<Msfabricationindustrial />} />
<Route path="/Industrial-Fabrication-Services-in-Pune" element={<Industrialfabrication />} />
<Route path="/Furniture-Work-Services-in-Pune" element={<Furniturework />} />
<Route path="/Industrial-Work-Services-in-Pune" element={<Industrialwork />} />
<Route path="/Home-Renovation-Work-Services-in-Pune" element={<Homerenovation />} />
<Route path="/Foil-Ceiling-Work-Services-in-Pune" element={<Foilceiling />} />
<Route path="/Painting-Work-Services-in-Pune" element={<Paintingwork />} />
<Route path="/Electrical-Work-Services-in-Pune" element={<Electricwork />} />
<Route path="/Puff-Panel-Room-Installation-in-Pune" element={<Puffpanelroom />} />
<Route path="/Maintenance-Repair-Services-in-Pune" element={<Maintenancerepail />} />
<Route path="/PCC-Epoxy-Flooring-Work-Services-in-Pune" element={<Pccepoxyflooring />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
